module.exports = __webpack_public_path__ + "img/student_26.eb3943ab.png";